import React from "react";
import PropTypes from "prop-types";

import { Icon } from "semantic-ui-react";

import Popper from "components/Popper";

export function DeletedCRMContactWarning({ show, message, ...popperProps }) {
  if (!show) return null;

  return (
    <Popper
      on="hover"
      offset="-10px,0"
      trigger={
        <Icon
          data-test="deleted-crm-contact-warning"
          name="exclamation triangle"
          color="yellow"
        />
      }
      {...popperProps}
    >
      {message}
    </Popper>
  );
}

DeletedCRMContactWarning.propTypes = {
  message: PropTypes.string,
  show: PropTypes.bool,
};

DeletedCRMContactWarning.defaultProps = {
  show: false,
  message:
    "This contact was removed from your CRM. Please open Client Card to merge.",
};

export default DeletedCRMContactWarning;
